export const state = () => ({
	drawer: localStorage.getItem("drawer") === "true",
});

export const mutations = {
	drawer(state, payload) {
		localStorage.setItem("drawer", payload);
		state.drawer = payload;
	},
};

export const getters = {
	drawer: (state) => {
		return state.drawer;
	},
};
